import React from 'react';

import { Route } from '@react-router';
import { ClarityService } from '../microsoftClarity';

// Dedicated Clarity project for hotel booking flows (PDP + Checkout) to collect
// higher-volume recordings for fraud review and checkout analysis.
const HOTEL_BOOKING_CLARITY_PROJECT_ID = 'wgc2eun3qk';

/**
 * Conditionally include external service scripts based on route
 */
export const RouteBasedServices = () => {
  return (
    <>
      {/* Admin registry + shop (admin + public) + admin room blocks */}
      <Route
        path={[
          '/:eventHandle/edit/registry',
          '/:eventHandle/edit/accommodations',
          '/shop',
          '/:eventHandle/edit/planning/hotelblock',
          '/createwedding',
          '/createbabyregistry',
          '/:eventHandle/travel',
        ]}
        render={() => {
          return <ClarityService />;
        }}
      ></Route>
      {/* exact to avoid prefix-matching hotel PDP (/:eventHandle/accommodations/:accommodationId) */}
      <Route
        exact
        path="/:eventHandle/accommodations"
        render={() => {
          return <ClarityService />;
        }}
      ></Route>
      {/* Hotel PDP + Checkout: separate Clarity project for fraud tracking */}
      <Route
        path={['/travel/checkout', '/travel/reservations', '/:eventHandle/accommodations/:accommodationId', '/stays/:stayId']}
        render={() => {
          return <ClarityService projectId={HOTEL_BOOKING_CLARITY_PROJECT_ID} />;
        }}
      ></Route>
    </>
  );
};
